import * as types from "./constants";
import update from 'immutability-helper';

const initialState = {
  guestlistData: [],
  fetchingGuestlist: true,
  searchText: ''
};

function guestListReducer(state=initialState, action) {
  switch (action.type) {
    case types.HYDRATE_GUESTLIST:
      return update(state, {
        guestlistData: {$set: action.data},
        fetchingGuestlist: {$set: false}
      });
    case types.UPDATE_SEARCH_TEXT:
      return update(state, {
        searchText: {$set: action.searchText}
      });
    default:
      return state
  }
}

export default guestListReducer;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/guestlist/reducers.es6